<template>
  <multiselect
    ref="multiselect"
    v-bind="context.attributes"
    v-model="context.model"
    open-direction="bottom"
    :class="`formulate-input-element formulate-input-element--${context.type}`"
    :custom-label="customLabel"
    :data-type="context.type"
    :options="options"
    :internal-search="false"
    :loading="isLoading"
    :max-height="200"
    @close="handleClose"
    @open="handleRepositionDropdown"
    @search-change="handleSearchChange"
    @input="handleInput"
  >
    <!-- TECHDEBT: find a better way to get selected option label -->
    <template #singleLabel>
      <div>
        {{ selectedOptionLabel }}
      </div>
    </template>

    <template #option="{ option }">
      <div
        :class="{
          'selected-option': context?.model
            ? option?.id == context?.model
            : option?.id == context?.value,
        }"
      >
        {{ option.name }}
      </div>
    </template>

    <template #noResult>
      <div>Tidak ada data</div>
    </template>
    <!-- Slot: after the list of options, when this element is in view, do api call -->
    <template #afterList>
      <div v-if="isLoading" class="px-2 py-2 d-flex gap-3 flex-column">
        <b-skeleton v-for="(i, idx) in ['100', '100']" :width="i" :key="idx"></b-skeleton>
      </div>
      <div v-observe-visibility="onElementObserved" v-if="hasNextPage" />
    </template>
  </multiselect>
</template>

<script>
// TODO:
// - Better optionGetter handling
//   - limit and pagination set (field props?)
import Multiselect from 'vue-multiselect'
import { debounce } from '@/mixin/helper'

export default {
  components: {
    Multiselect,
  },
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      options: [],
      limit: 5,
      page: null,
      totalPage: null,
      optionsSearch: '',
      isLoading: false,
      lastSelected: null,
      multiselectList: null,
    }
  },
  computed: {
    hasNextPage() {
      if (this.totalPage === null) return true
      return this.page + 1 <= this.totalPage
    },
    selectedOptionLabel() {
      return (
        this.lastSelected?.name || this.context.attributes.customLabelFn({ context: this.context })
      )
    },
  },
  mounted() {
    this.multiselectList = this.$refs.multiselect?.$refs?.list
    window.addEventListener('scroll', this.handleRepositionDropdown)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleRepositionDropdown)
  },
  methods: {
    handleRepositionDropdown() {
      const { top, height } = this.$el.getBoundingClientRect()
      this.multiselectList.style.width = `${this.$el.clientWidth}px`
      this.multiselectList.style.position = 'fixed'
      this.multiselectList.style.bottom = 'auto'
      this.multiselectList.style.top = `${top + height}px`
    },
    customLabel(item) {
      return this.context.attributes.customLabelFn({
        item,
        context: this.context,
        options: this.options,
      })
    },
    handleInput(input) {
      this.lastSelected = input
      this.context.model = input.id
    },
    handleSearchChange: debounce(async function (search) {
      if (this.isLoading) return
      if (this.multiselectList?.scrollTop) {
        this.multiselectList.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }

      this.isLoading = true

      const res = await this.context.attributes.resourcefulOptionsGetter({
        limit: this.limit,
        page: 1,
        search,
      })

      const options = res.data.paginated_result
      this.totalPage = res.metadata.total_page
      this.page = res.metadata.page
      this.options = options
      this.optionsSearch = search
      this.isLoading = false
    }, 500),
    handleClose() {
      this.context.blurHandler()
    },
    async onElementObserved(isVisible) {
      if (!isVisible) return
      if (this.isLoading) return
      this.isLoading = true

      await this.$nextTick()

      if (this.multiselectList?.scrollTop) {
        this.multiselectList.scrollTo({
          top: this.multiselectList.scrollHeight,
          behavior: 'smooth',
        })
      }

      const res = await this.context.attributes.resourcefulOptionsGetter({
        limit: this.limit,
        page: this.page ? this.page + 1 : 1,
        search: this.optionsSearch,
      })

      const options = res.data.paginated_result
      this.totalPage = res.metadata.total_page
      this.page = res.metadata.page
      this.options = [...this.options, ...options]
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.selected-option::after {
  content: '✓';
  color: $white;
  background-color: #137c55;
  padding: 0 4px;
  line-height: normal;
  border-radius: 100%;
  font-size: 11px;
  position: absolute;
  top: 12px;
  right: 12px;
}
</style>
